import * as Yup from "yup";

import { m } from "@vega-core/paraglide/messages";

export const getNewCategoryValidationSchema = () =>
  Yup.object().shape({
    name: Yup.string()
      .trim()
      .required(
        m.formValidation_required({
          name: m.cases_settings_category_name(),
        }),
      ),
    description: Yup.string().nullable(),
    slaHours: Yup.number()
      .transform((value, originalValue) =>
        String(originalValue).trim() === "" ? undefined : value,
      )
      .typeError(m.cases_settings_slaRequired())
      .required(m.cases_settings_slaRequired())
      .integer(m.cases_settings_slaRequired())
      .positive(m.cases_settings_slaRequired()),
  });
